import React from 'react';
import { BREEDS } from '../data/mock';

export const BreedFilter = ({ selectedBreed, onSelectBreed }) => {
  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 mb-8 border border-amber-100">
      <h2 className="text-lg font-semibold text-amber-900 mb-4">Filtrar por Raza</h2>
      <div className="flex flex-wrap gap-3">
        <button
          data-testid="breed-filter-all"
          onClick={() => onSelectBreed(null)}
          className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
            selectedBreed === null
              ? 'bg-amber-600 text-white shadow-md transform scale-105'
              : 'bg-amber-50 text-amber-800 hover:bg-amber-100 border border-amber-200'
          }`}
        >
          Todas las razas
        </button>
        {BREEDS.map((breed) => (
          <button
            key={breed.id}
            data-testid={`breed-filter-${breed.id}`}
            onClick={() => onSelectBreed(breed.id)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 flex items-center gap-2 ${
              selectedBreed === breed.id
                ? 'bg-amber-600 text-white shadow-md transform scale-105'
                : 'bg-amber-50 text-amber-800 hover:bg-amber-100 border border-amber-200'
            }`}
          >
            <span>{breed.icon}</span>
            <span>{breed.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
